import { DraggableItemTypes } from 'owa-dnd';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export default function isCalendarGroupBeingDragged(scenarioId: CalendarPickerScenarioId): boolean {
    const store = getCalendarPickerStore(scenarioId);
    return (
        store.draggedItemData &&
        store.draggedItemData.itemType === DraggableItemTypes.CalendarGroupNode
    );
}
